var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollection = function SvgCollection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0h-14a.47.47 0 0 0-.5.5v14a.47.47 0 0 0 .5.5h14a.47.47 0 0 0 .5-.5V.5a.47.47 0 0 0-.5-.5m-1.1 14H3.6a.65.65 0 0 1-.6-.6V1.6a.65.65 0 0 1 .6-.6h11.9a.65.65 0 0 1 .6.6v11.9a.94.94 0 0 1-.7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16H1.6a.65.65 0 0 1-.6-.6V2.5a.5.5 0 0 0-1 0v14a.47.47 0 0 0 .5.5h14a.5.5 0 0 0 0-1"
  })));
};
export default SvgCollection;